// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { orderTotalDisplaySharedStyles } from "@awc/App/SharedStyles/MyAccountPages/Details/OrderTotalDisplaySharedStyles";
import { totalStyles } from "@awc/Overrides/Widgets/InvoiceDetails/InvoiceDetailsTotal";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { mergeWithCss, xScreen } from "@awc/XDL/Utilities";
import { css } from "styled-components";

totalStyles.labelGridItem = {
    ...orderTotalDisplaySharedStyles.labelGridItem,
};
totalStyles.valueGridItem = {
    ...orderTotalDisplaySharedStyles.valueGridItem,
};
totalStyles.subtotalLabelText = {
    ...orderTotalDisplaySharedStyles.label,
};
totalStyles.subtotalValueText = {
    ...mergeWithCss(orderTotalDisplaySharedStyles.value, { weight: fontConfig.weight.regular }),
};
totalStyles.discountsLabelText = {
    ...orderTotalDisplaySharedStyles.label,
};
totalStyles.discountsValueText = {
    ...mergeWithCss(orderTotalDisplaySharedStyles.value, { weight: fontConfig.weight.regular }),
};
totalStyles.shippingAndHandlingLabelText = {
    ...orderTotalDisplaySharedStyles.label,
};
totalStyles.shippingAndHandlingValueText = {
    ...mergeWithCss(orderTotalDisplaySharedStyles.value, { weight: fontConfig.weight.regular }),
};
totalStyles.otherChargesLabelText = {
    ...orderTotalDisplaySharedStyles.label,
};
totalStyles.otherChargesValueText = {
    ...mergeWithCss(orderTotalDisplaySharedStyles.value, { weight: fontConfig.weight.regular }),
};
totalStyles.taxLabelText = {
    ...orderTotalDisplaySharedStyles.label,
};
totalStyles.taxValueText = {
    ...mergeWithCss(orderTotalDisplaySharedStyles.value, { weight: fontConfig.weight.regular }),
};
totalStyles.totalLabelText = {
    ...orderTotalDisplaySharedStyles.totalLabel,
    ...mergeWithCss(orderTotalDisplaySharedStyles.totalLabel, {
        weight: fontConfig.weight.bold,
    }),
};
totalStyles.totalValueText = {
    ...orderTotalDisplaySharedStyles.totalValue,
};

totalStyles.container = {
    ...mergeWithCss(orderTotalDisplaySharedStyles.mainContainer, {
        offsetCss: css`
            row-gap: 8px;
        `,
    }),
};
totalStyles.fullWidthGridItem = {
    width: 12,
};
totalStyles.invoiceSummaryLabel = {
    ...orderTotalDisplaySharedStyles.titleText,
};
totalStyles.styledHr = {
    ...orderTotalDisplaySharedStyles.styledHr,
};
